"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChannelFactory = void 0;
const types_1 = require("../types");
const IngestType_1 = require("../sub-clients/channels/model/IngestType");
class ChannelFactory {
    static createChannelResource(resource = {}) {
        return {
            id: '123',
            name: 'content partner name',
            official: true,
            distributionMethods: [],
            _links: {},
            ...resource,
        };
    }
    static sample(channel = {}) {
        const id = channel.id || '123';
        return {
            id,
            name: channel.name || 'Test name',
            currency: channel.currency || 'USD',
            legalRestriction: channel.legalRestriction || {
                id: '2',
                text: 'a legal restriction',
            },
            ingest: channel.ingest || { type: IngestType_1.IngestType.MANUAL },
            links: channel.links || {
                self: new types_1.Link({
                    href: `/v1/channels/${id}`,
                }),
            },
            distributionMethods: channel.distributionMethods || ['STREAM'],
            description: channel.description || 'this is a description',
            language: channel.language || { code: 'spa', name: 'Spanish' },
            contentCategories: channel.contentCategories || [
                { key: 'ANY_KEY', label: 'Any label' },
            ],
            notes: channel.notes || 'Something noteworthy',
            contentType: channel.contentType || 'INSTRUCTIONAL',
            oneLineDescription: channel.oneLineDescription || '30-year-old mulberry field',
            marketingInformation: channel.marketingInformation || {
                status: 'IN_PROGRESS',
                logos: ['logo1.png', 'logo2.png'],
                showreel: 'showreel.mkv',
                sampleVideos: ['sample1.avi', 'sample2.avi'],
            },
            pedagogyInformation: channel.pedagogyInformation || {
                subjects: [
                    '5cb499c9fd5beb428189454b',
                    '5cb499c9fd5beb428189454d',
                    '5cb499c9fd5beb428189454e',
                ],
                bestForTags: [
                    '5d3ac0175b3f3b7ba335e104',
                    '5d3ac0185b3f3b7ba335e106',
                    '5d3ac0185b3f3b7ba335e105',
                ],
                ageRanges: {
                    min: 10,
                    max: 20,
                    label: '10-20',
                    ids: ['123'],
                },
            },
            taxonomy: channel.taxonomy || {
                categories: [
                    {
                        codeValue: 'ABC',
                        description: 'a lovely description',
                    },
                ],
            },
            contractId: '123',
            contractName: 'the contract',
            educationLevels: channel.educationLevels || [],
        };
    }
}
exports.ChannelFactory = ChannelFactory;
//# sourceMappingURL=ChannelsFactory.js.map